import {
  Component, Input,
  OnInit, Output, EventEmitter
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {CheckboxModule} from 'primeng/checkbox';
import {PaginatorModule} from 'primeng/paginator';
import {TooltipModule} from 'primeng/tooltip';
import {FormsModule} from '@angular/forms';
import {DataTableComponent} from '@components/data-table/data-table.component';
import {Loading} from '@components/ui/loading/loading';
import {MsfNumber} from '@app/utils/pipes/format-number';


@Component({
  selector: 'app-dynamic-data-table',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    TableModule,
    ButtonModule,
    CheckboxModule,
    PaginatorModule,
    TooltipModule,
    FormsModule,
    Loading,
    MsfNumber
  ],
  templateUrl: './dynamic-data-table.component.html',
  styleUrl: './dynamic-data-table.component.scss',
})
export class DynamicDataTableComponent extends DataTableComponent implements OnInit {
  @Output() override onRowClick = new EventEmitter<any>();

  @Input({required:true}) override storageKey: any = '';

  override  ngOnInit() {
    super.ngOnInit();
  }

  override onPageChange(pageNumber: { first: number; rows: number }) {
    this.params.offset = pageNumber.first;
    this.params.take = pageNumber.rows;
    this.first = pageNumber.first;
    this.loadData();
  }


  onPageSizeChange(rows: number) {
    this.params.take = rows;
    this.params.offset = 0;
    this.first = 0;
    this.loadData();
  }


  override onRowClickChange(row: any) {
    this.onRowClick.emit(row);
  }

  get currentPageReportTemplate(): string {
    return `{first} - {last} ${this.tr.instant('of')} {totalRecords}`;
  }

  /**
   * Format file size from bytes to KB, MB, GB, etc.
   * Starts from KB (minimum display unit)
   */
  formatFileSize(bytes: number): string {
    if (!bytes || isNaN(bytes) || bytes === undefined || bytes === null || bytes === 0) {
      return '0 KB';
    }

    const k = 1024;
    const sizes = ['Kb', 'Mb', 'Gb', 'Tb'];
    const bytesInKB = bytes / k;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const sizeIndex = Math.max(0, i - 1);

    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + this.tr.instant(sizes[sizeIndex]);
  }

}
